<template>

	<div class="landing-codeOfConduct">
		<section class="container-fluid">
			<div class="text-center headline-container">  
		  	 	<h1 class="headline">Supplier Code of Conduct</h1>
		 	</div>
			<div v-if="terms.length" v-html="terms" class="container block-text">  
		 	</div>
		</section>
	</div>

</template>

<script>
	import apiConnection from '../mixins/apiConnection.js';
	import seoModule from "../mixins/seoModule.js";

	export default{
		name: 'Terms',
		data () {
		   return {
		   		terms:[]
		   }
		},
		created(){
			this.getCodeOfConduct();
		},

		mixins:[apiConnection,seoModule],


	}
</script>


// WEBPACK FOOTER //
// CodeOfConduct.vue?6e424832